var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 41.324 48.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "apple_svg__Apple_logo_black",
    d: "M34.579,48.025c-2.658,2.579-5.59,2.177-8.385.961a10.623,10.623,0,0,0-8.826,0c-3.908,1.687-5.982,1.2-8.336-.961C-4.257,34.344-2.3,13.5,12.807,12.719c3.663.2,6.228,2.025,8.385,2.177,3.207-.652,6.277-2.52,9.709-2.275q6.186.5,9.268,4.889a10.779,10.779,0,0,0,1.319,19.418c-1.559,4.094-3.56,8.14-6.914,11.131ZM20.9,12.572A11.164,11.164,0,0,1,31.1,1C31.877,8.012,24.723,13.259,20.9,12.572Z",
    transform: "translate(-0.164 -1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.66bb2382c4a387f94e7145c49912c58f.svg";
export { ForwardRef as ReactComponent };